module.exports = __webpack_public_path__ + "static/section-5-7544633ba1c7af5e8af158f480360672.jpg";